var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 3.64844H2.66536C1.92898 3.64844 1.33203 4.24539 1.33203 4.98177V12.9818C1.33203 13.7181 1.92898 14.3151 2.66536 14.3151H13.332C14.0684 14.3151 14.6654 13.7181 14.6654 12.9818V4.98177C14.6654 4.24539 14.0684 3.64844 13.332 3.64844Z",
    stroke: "#3581E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 5.64844L8.68536 9.44844C8.47955 9.57739 8.24158 9.64578 7.9987 9.64578C7.75582 9.64578 7.51785 9.57739 7.31203 9.44844L1.33203 5.64844",
    stroke: "#3581E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.667484873777ca424a30d5cd4ce8178c.svg";
export { ForwardRef as ReactComponent };